import React from 'react'
import { View } from '../other/html'
import { COLORS } from '../../theme'

import Loader from './Loader'
import Text from './TextNew'

interface Props {
  variant?: 'normal' | 'small' | 'medium' | 'smallWithIcon'
  children: string | JSX.Element
  onClick: () => void
  customStyles?: string
  color?: keyof typeof COLORS | 'transparent'
  iconComponent?: JSX.Element
  dataTestId?: string
  disabled?: boolean
  isLoading?: boolean
}

const Button = ({
  children,
  onClick,
  customStyles,
  color = 'successGreen',
  disabled = false,
  variant = 'normal',
  iconComponent,
  isLoading,
  dataTestId
}: Props): JSX.Element => {
  const cursorStyles = disabled ? 'cursor-not-allowed' : 'cursor-pointer'
  return (
    <View
      className={`${customStyles ?? ''} ${
        variantStyles[variant]
      } bg-${color} ${cursorStyles} rounded-[10px] flex items-center justify-center ${disabled ? 'opacity-80' : ''}`}
      onClick={onClick}
      data-testid={dataTestId}>
      {iconComponent}
      <View className="flex-1" />
      <View>
        <Text className={`font-SemiBold text-white ${variant === 'normal' ? 'text-xl' : 'text-l'}`}>{children}</Text>
      </View>
      <View className="flex-1 items-center justify-center flex">
        <Loader isLoading={isLoading} />
      </View>
    </View>
  )
}
const variantStyles = {
  normal: 'py-4 items-center',
  small: 'px-3 py-3',
  medium: 'px-5 py-3',
  smallWithIcon: 'px-3 py-1'
}

export default Button
